export const EN = {
  "general.search": "Search",

  //HEADER
  "header.time": "Moscow time",
  "menu.about": "About",
  "menu.locations": "Locations",
  "menu.transportation": "Transportation",
  "menu.contacts": "Contacts",
  "menu.call": "Order a call",
  "menu.sign": "Sign up",
  "menu.login": "Login",
  "menu.machines": "Machines",
  "menu.spareparts": "Spare parts",
  "menu.clients": "Clients",
  "menu.settings": "Settings",
  "menu.locations_login": "Locations",
  "menu.managment": "Managment",
  "menu.messenger": "Messenger",
  "menu.notifications": "Notifications",
  "menu.login_account": "Account",
  "menu.login_logout": "Logout",
  //HOME PAGE
  "main.title.bold": "Cheap",
  "main.title": "& reliable mining colocations",
  "main.who.1": "Who we are",
  "main.who.2": "& What we do",
  "main.who.btn": "White paper",
  "calc.title.bold": "Calculate",
  "calc.reset": "Reset",
  "calc.title": "your earnings",
  "calc.miner": "Select miner",
  "calc.algo": "Algorithm used in calculations",
  "calc.curr": "$",
  "calc.el": "Electricity cost ($/kWh):",
  "calc.perf": "Performance:",
  "calc.perf.err": "with error:",
  "calc.efficiency": "Miner efficiency:",
  "calc.efficiency.bage": "TH/kW",
  "calc.err": "Error:",
  "calc.revenue": "Your revenue ($):",
  "calc.cons": "Consumption:",
  "calc.cons.bage": "kWh",
  "calc.income": "Your income after electricity expenses ($):",
  "calc.add": "Add Another Device",
  "calc.save": "Save",
  "calc.day": "day",
  "main.contact.btn": "Order request",
  "main.subscribe": "Subscribe",

  "banner1.bold": "Spend 30%",
  "banner1.title": "less by hosting your equipment with us",
  "banner2.bold": "Host",
  "banner2.title": "with one of the most reliable power producers",
  "banner3.bold": "Generate",
  "banner3.title": "steady returns from the very beginning",
  "banner4.bold": "See",
  "banner4.title": "how far $100k can go",

  "review1.subtitle": "Investment Banker",
  "review1.descr":
    "I already had some miners in Kazakhstan, but decided to change location. My contract was expiring and I was also afraid of the civil unrest. These guys helped me to relocate the equipment and it is all going well so far.",
  "review1.main.bold": "Our study",
  "review1.main.span": "indicates that",
  "review1.main.text":
    "an average colocation charges its users around 8 to 8.5 cents per kilowatt (including maintenance), while we offer placement for only 6.6 cents/kWh. It is 30% cheaper! Only those with the lowest electricity costs will survive depressive market trends and increasing difficulty, which means that Bitcoin mining in areas with cheapest electricity represents a good and not very long lasting opportunity. This can be your competitive advantage against other miners.",
  "review2.subtitle": "Director of the Mining department",
  "review2.descr":
    "I've been hosting machines at this mining hotel for almost a year and had no issues. They seem not to have budget constraints like many of the smaller companies do, so they always have enough people on the ground. I plan to increase the number of machines this year.",
  "review2.main.bold": "We are not the middleman",
  "review2.main.text":
    ", like many in this business. We are operators of the second largest private power generation corporation in Russia, this company is a part of a bigger holding established over 20 years ago. Our expansion plans include increasing cryptocurrency mining capacity to 50MW in 2022. Our 5-year plan is to make 2,000MW available by 2027. All facilities are protected by the armed security, equipped with surveillance cameras, and staffed with engineers to perform regular maintenance procedures that miners need. All power plants are located in Siberia, where the unique climate conditions can keep your equipment cool at around +2C (36F), making it last longer. Hydro electric stations are playing a bigger role in the region and help to reduce carbon footprint – 60% of power produced in Siberia last year came from renewable sources.",
  "review3.subtitle": "Cryptocurrency Miner",
  "review3.descr":
    "At first I was skeptical about all of these, so I started with just 10 miners. After a while I sold them all to my friends, purchased another 10 and then sold them all too. Now I have 47 Antminer S19 machines that I keep for myself. I didn't know I could sell machines, but one of the managers at your mining facility suggested me to try and it really worked, thank you! Great advice.",
  "review3.main.bold": "We've created a solution",
  "review3.main.text":
    "that allows you to invest in crypto mining without overpaying for kilowatts. Our mining hotel / crypto equipment colocation isn't limited to shelf space and a power outlet, we can help you to select equipment, advise you on taxation matters, and suggest various investment paths.",
  "review4.subtitle": "Private Investor",
  "review4.descr":
    "Initially I sent some machines that were lying around in my Hong Kong warehouse. Then I decided to increase my crypto presence and made a bank transfer to buy equipment directly in Russia, because the price was the same as if I bought from China. Guys helped me to buy machines in Moscow and shipped them to Siberia for installation. Transaction was smooth and without much delays.",
  "review4.main.bold": "",
  "review4.main.text": "",
  //
  "last_review.title.bold": "Did you know",
  "last_review.title.text":
    "that we can buy and install miners for you? No experience required! You can invest through our Switzerland branch and even purchase pre-installed miners that are waiting for you on the shelves.",
  "last_review.calc.text": "Here are some basic calculations:",
  "last_review.calc.list1":
    "100 kWh at a price of $0.055 comes out to $3,960 per month.",
  "last_review.calc.list2": `100kWh can cover 30 "Antminer S19" (95 Th/s) machines: this means
    investing roughly $300k in new equipment (price changes according to the
    market). This particular model will be OK for the next five years.`,
  "last_review.calc.list3":
    "If you have your own miners we will be more than happy to help with shipping and customs matters.",
  "last_review.calc.list4": `With the Bitcoin price staying on ~$45,000 levels and total network
    hashrate being on 185.85 EH/s, each miner can bring approximately $15/day
    after the electrical charges. All 30 miners will bring a total income of
    $450/day. You will need 22 months to reach the breakeven point.`,

  "last_review.calc.list5": `Making the money back that quick is possible because of the cheap and stable
  electrical supply. This is the best value for the money among all investment
  opportunities, since so many mining hotels provide such rates to the
  multi-megawatt investors only.`,

  "accordion.title.bold": "What",
  "accordion.title.text": "else do we offer?",
  //
  "accordion.1.title.bold": "Flexible",
  "accordion.1.title.text": "payment terms",
  "accordion.1.descr":
    "While most mining collocations ask you to leave security deposit and pay the 1st month upfront, with us you can simply pay for electricity from your mining proceeds.",
  "accordion.2.title.bold": "Flexible",
  "accordion.2.title.text": "hosting terms",
  "accordion.2.descr":
    "Usually 1 year is the average contract period. Have something different in mind? Talk to us and we'll try to adapt for your needs.",
  "accordion.3.title.bold": "Equipment",
  "accordion.3.title.text": "maintenance",
  "accordion.3.descr":
    "Cleaning and basic maintenance is included in your price per kWh.",
  "accordion.4.title.bold": "Equipment",
  "accordion.4.title.text": "repairs",
  "accordion.4.descr":
    "We have our own lab to ensure faster turnaround times, but we will need to charge you additionally for parts and labor (with your prior approval).",
  "accordion.5.title.bold": "Cash",
  "accordion.5.title.text": "investments",
  "accordion.5.descr":
    "Even if you don't have the equipment but want to start mining, you can still count on us. We accept cash transfers which we use to purchase miners and transport them to the mining facilities. Depending on the market situation, we buy miners directly from China (with the quality control performed by our agents in Shenzhen) or in Russia (with the quality control performed by our agents in Moscow).",
  "accordion.6.title.bold": "Assistance",
  "accordion.6.title.text": "with customs / transportation",
  "accordion.6.descr":
    "We are happy to do our best and assist your for free when you are shipping your equipment to us.",
  "accordion.7.title.bold": "Selling",
  "accordion.7.title.text": "installed miners",
  "accordion.7.descr":
    "We will be more than happy to arrange a deal with another miner who wishes to expand their mining operations or buy your equipment ourselves. Whenever you decide to sell, shoot us a message and we'll check local market prices and suggest a fair number.",
  "accordion.8.title.bold": "Buying",
  "accordion.8.title.text": "installed miners",
  "accordion.8.descr":
    "There might be something available for you right now, don't wait, just ask and we'll respond with current offerings ASAP.",
  "accordion.9.title.bold": "Relocating",
  "accordion.9.title.text": "miners",
  "accordion.9.descr":
    "Whether you decide to ship your machines to another mining farm or export them abroad, we are here to help you. Depending on your contract terms, you might be able to stop operations with the advance notice and ask us to ship machines elsewhere.",
  "options.title.bold": "Select",
  "options.title": "the way you want machines to be hosted",
  "options.subtitle": `We offer several options. Depending on your needs, you can have your equipment placed on
    shelves in an industrial building or outside in a mining container.`,

  "locations.title.bold": "Locations",

  "location.rental": "Rental cost",
  "location.rental.cost": "0.07 USD / kWh incl. VAT",
  "location.cap.total.title": "Total planned capacity",
  // только для Черногорска
  "location.cap.total.title-4ernogorsk": "Total capacity",
  //
  "location.curr.cap.title": "Current capacity",
  "location.cap.currency": "MW",
  "location.cap.title": "Available capacity",
  "location.connection.title": "Connection",
  "location.connection.text": "220V / 380V",
  //
  "locations.1.title": "1. Krasnoyarsk",
  "locations.1.cap": "90 MW",
  "locations.2.title": "2. Kemerovo",
  "locations.2.cap": "50 MW",
  "locations.3.title": "№ 3 Krasnoyarsk",
  "locations.3.cap": "20 MW",
  "locations.4.title": "№ 4 Krasnoyarsk",
  "locations.4.cap": "60 MW",
  "locations.5.title": "№ 5 Sosnovoborsk",
  "locations.5.cap": "100 MW",
  "locations.6.title": "3. Chernogorsk",
  "locations.6.cap": "8 MW",

  "locations.scheme.miners_start": "Are you sure you want to start # miners?",
  "locations.scheme.miners_stop": "Are you sure you want to stop # miners?",
  "locations.scheme.miners_restart":
    "Are you sure you want to restart # miners?",

  "locations.scheme.one_miner_start": "Are you sure you want to start miner #?",
  "locations.scheme.one_miner_stop": "Are you sure you want to stop miner #?",
  "locations.scheme.one_miner_restart":
    "Are you sure you want to restart miner #?",

  "location.diagram.title": "Connection Diagram",
  "location.diagram.clear_field": "Clear Field",
  "location.diagram.undo": "Undo",
  "location.diagram.redo": "Redo",
  "location.diagram.save": "Save",
  "location.diagram.reload": "Reload",
  "location.diagram.cell_element": "cell",
  "location.diagram.transformer_element": "transformer",
  "location.diagram.counter_element": "counter",
  "location.diagram.shield_element": "shield",
  "location.diagram.consumer_element": "consumer",
  "location.diagram.network_element": "_",
  "location.diagram.rack": "Rack",
  "location.diagram.section": "Cell",
  "location.diagram.building": "Building",
  //'cell' | 'transformer' | 'counter' | 'shield' | 'consumer' | 'network' | 'building' | "square" | "triangle" | "circle" | "diamond"
  "location.diagram.type_cell": "Element",
  "location.diagram.type_transformer": "Transformer",
  "location.diagram.type_counter": "Counter",
  "location.diagram.type_shield": "Shield",
  "location.diagram.type_consumer": "Consumer",
  "location.diagram.type_network": "Network",
  "location.diagram.type_building": "Building",
  "location.diagram.type_square": "Square",
  "location.diagram.type_triangle": "Triangle",
  "location.diagram.type_circle": "Circle",
  "location.diagram.type_diamond": "Diamond",
  "location.diagram.refresh": "Refresh",
  "location.diagram.node_action.reset": "Reboot",
  "location.diagram.node_action.edit": "Edit",
  "location.diagram.node_action.delete": "Delete",
  "location.diagram.node_action.start": "Start",
  "location.diagram.node_action.stop": "Stop",
  "location.diagram.node_action.turn_on": "Turn on",
  "location.diagram.node_action.turn_off": "Turn off",
  "location.diagram.unlock_to_drop": "The diagram is locked. Unlock editing to add the element.",

  "if_you.title.bold": "If you",
  "if_you.title": "don't have the equipment",
  //
  "option.1.main.title": "Option 1",
  "option.1.title.bold": "Purchase",
  "option.1.title.text": "pre-installed machines",
  "option.1.descr.bold": "Sometimes we offer",
  "option.1.descr": `pre-installed miners for sale. They may come from
    other users or from our own pool. If you are interested, we will send you information
    about what's available, take pictures and videos of the equipment, and provide you
    with the serial numbers, so you can make an informed decision.`,
  "option.2.main.title": "Option 2",
  "option.2.title.bold": "Purchase",
  "option.2.title.text": "Machines from distributors",
  "option.2.descr.bold": "We've been working",
  "option.2.descr": `with crypto long enough to know all the major
  distributors in China. If you have a large order you might be able to get better price
  and faster shipping time compared to the official channels. Due to the volatile nature
  of the market, we can't list prices here, but we will be happy to quote you by email
  or messenger of your choice.`,
  "have_equipment.title.bold": "If you",
  "have_equipment.title": "have the equipment",
  "main.bottom.btn": "Contact us with additional questions",

  //COMMAND STATUS
  "command.status.unknown": "Unknown",
  "command.status.new": "New",
  "command.status.sending": "Sending",
  "command.status.pending": "Pending",
  "command.status.done": "Done",
  "command.status.error": "Error",
  "command.status.unavailable": "Unavailable",

  //LOGIN PAGE
  "login.title": "Log in",
  "login.email": "Email",
  "login.password": "Password",
  "login.btn": "Log in",
  "login.forgot": "Forgot your password?",
  //
  "registration.title": "Sign up",
  "registration.already": "Already have account? Click here to",
  "registration.email": "Email",
  "registration.password": "Password",
  "registration.repeat": "Repeate password",
  "registration.policy":
    "By clicking Create account, I agree that I have read and accepted the {link} of Use and Privacy policy",
  "registration.policy.link": "Terms",
  "registration.btn": "Create account",

  //WLP 202603
  "wlp.header.videoReviews": "Video reviews",
  "wlp.header.benefits": "Our benefits",
  "wlp.header.contact": "Contact us",
  "wlp.auth.description":
    "Enter your account details to access the monitoring dashboard.",
  "wlp.hashrate.title": "Recent Hashrate",
  "wlp.hashrate.activeMiners": "2205 active miners connected to the site",
  "wlp.hashrate.activeMinersSuffix": "active miners connected to the site",
  "wlp.hashrate.timePeriod": "Time period",
  "wlp.reviews.heading": "Video reviews",
  "wlp.reviews.1": "Recent hashrate and state changes in time",
  "wlp.reviews.2": "Settings and filters",
  "wlp.reviews.3": "All miners and tabs",
  "wlp.reviews.4": "Technical errors and miner profile",
  "wlp.reviews.5": "Multiple miner selection and control",
  "wlp.reviews.6": "Pool settings and status",
  "wlp.reviews.7": "Miner models and sleep schedules",
  "wlp.reviews.8": "Client management and statistics",
  "wlp.reviews.9": "Excel report and uptime calculation",
  "wlp.reviews.10": "Locations and their statistics",
  "wlp.benefits.heading": "Our benefits",
  "wlp.benefits.1.title": "Freemium Miner Management Software",
  "wlp.benefits.1.description":
    "Unlike traditional mining management platforms that charge high fees, WattLord provides a free monitoring system with premium features exclusive to its subscribers. This reduces operational costs for miners, as they do not have to pay for basic tools.",
  "wlp.benefits.2.title": "Advanced Operational Tools for Large-Scale Mining",
  "wlp.benefits.2.description":
    "The platform includes unique features such as a visual representation of miners on shelves, NFC tags for electricians to check in at designated locations during shifts, and more, ensuring smoother operations and better oversight in large mining farms.",
  "wlp.benefits.3.title": "Optimized Pool Selection and Routing",
  "wlp.benefits.3.description":
    "The system allows operators to view their actual hashrate and select their final pool through the management panel with the click of a button, avoiding inefficient or hidden-fee pools and thereby maximizing earnings.",
  "wlp.benefits.4.title": "Highly Scalable and Reliable Infrastructure",
  "wlp.benefits.4.description":
    "WattLord utilizes a geographically diverse infrastructure, ensuring low latency, redundancy, and improved uptime for uninterrupted mining operations.",
  "wlp.benefits.5.title": "Detailed Excel Reports",
  "wlp.benefits.5.description":
    "Colocation operators can generate detailed Excel reports for their customers, providing an in-depth analysis of their miners' hashrate over a selected period. If a customer needs to know the exact times and dates their miners stopped, when hashrate dropped, time spent mining and idling, or their average speed and uptime, all this information can be found in a report that can be generated separately for each client.",
  "wlp.benefits.6.title": "Shutdown and Boost Calendars",
  "wlp.benefits.6.description":
    "Miners can be put to sleep to reduce energy consumption during selected days and times to match tariff requirements. Alternatively, they can be boosted at selected times when weather conditions and electricity costs are favorable.",
  "wlp.subscribe.title": "Newsletter",
  "wlp.subscribe.emailLabel": "Email",
  "wlp.subscribe.emailPlaceholder": "Enter your email",
  "wlp.subscribe.button": "Subscribe",
  "wlp.subscribe.success": "You have subscribed to the newsletter",
  "wlp.contact.title": "Contact us",
  "wlp.contact.emailLabel": "Email",
  "wlp.contact.emailPlaceholder": "Enter your email",
  "wlp.contact.messageLabel": "Message",
  "wlp.contact.messagePlaceholder": "Enter your message",
  "wlp.contact.send": "Send",
  "wlp.contact.success": "Your message was sent successfully",
  "wlp.form.emailRequired": "Email is required",
  "wlp.form.emailInvalid": "Please enter a valid email",
  "wlp.form.messageRequired": "Message is required",
  "wlp.form.recaptchaRequired": "Please verify you are not a robot",
  "wlp.form.genericError": "Something went wrong. Please try again later",
  "wlp.footer.terms": "Terms & conditions",
  "wlp.footer.privacy": "Privacy policy",
  "wlp.footer.cookie": "Cookie policy",
  "wlp.footer.refund": "Refund policy",
  "wlp.footer.acceptable": "Acceptable use policy",
  "wlp.footer.disclaimer": "Disclaimer",
  "wlp.footer.contact": "Contact us",
  "wlp.footer.copy": "© 2026 All rights reserved",

  //MACHINES PAGE
  "machines.title": "Machines",
  "machines.minersSection": "Miners",
  "machines.summary_btns.hash": "Recent Hashrate",
  "machines.summary_btns.state": "State changes in time",
  "machines.summary.hash": "Display graph",
  "machines.summary.state": "Display graph of states",
  "machines.chart.swicher.admin_and_users": "Admin and users",
  "machines.chart.swicher.admin_only": "Admin only",
  "machines.chart.settingsBtns": "Select Setting or Algorithm",
  "machines.chart.settings": "Settings",
  "machines.chart.algorithms": "Algorithms",
  "machines.filtersAndSettings.filters": "Filters",
  "machines.filtersAndSettings.settings": "Settings",
  "machines.minerSettings.show": "Miner settings",
  "machines.minerSettings.hide": "Hide settings",
  "machines.settings.speed_drops1": `if speed`,
  "machines.settings.speed_drops2": `drops below`,
  "machines.settings.from_speed_default": "from 'Speed (default)'",
  "machines.settings.notify_by": "Notify by:",
  "machines.settings.apply_btn": "Apply",
  "machines.settings.all_errors_clear": "Clear all errors",
  "machines.start_stop": "Commands",
  "machines.start_stop.start": "Start",
  "machines.start_stop.stop": "Stop",
  "machines.start_stop.reset": "Reset",
  "machines.start_stop.restart": "Restart",
  "machines.start_stop.booston.title": "Boost on",
  "machines.start_stop.boostoff.title": "Boost off",
  "machines.start_stop.check.title": "Check miner",
  "machines.start_stop.clear_errors": "Clear errors",
  "machines.add_miner": "+ Add New Miners",
  "machines.add_default_miner": "Default miner",
  "machines.add_cloned_miner": "With clonned settings",
  "machines.settings.pool_name": "Change Pool settings to",
  "machines.settings.customer": "Customer",
  "machines.settings.type": "Type",
  "machines.settings.location": "Location",
  "machines.settings.speed_default": "Speed (default)",
  "machines.settings.admin_income": "Admin mining income %",
  "machines.settings.adminMiningPool": "Admin mining pool",
  "machines.settings.plan": "Mining plan",
  "machines.settings.miner_name": "Miner name",
  "machines.settings.miner_id": "Miner ID",
  "machines.admin_mining": "Admin mining",
  "machines.admin_mining.various": "Various admin mining windows",
  "machines.smooth_switch": "Graph smoothing",
  "machines.settings.speed_drop_notif": "Notify you if the speed drops below",
  "machines.settings.num_miners": "The following changes will affect # miners:",
  //
  "chosen_miners.title_main": "Miners",
  "chosen_miners.title": "Total of chosen miners",
  "chosen_miners.total": "Total:",
  "chosen_miners.id": "ID",
  "chosen_miners.type": "Type",
  "chosen_miners.clear": "Clear",
  "chosen_miners.hint.clear": "Clear to apply new search options",

  //filters
  "filters.clear": "Clear",
  "filters.title": "Filter results by the following parameters",
  "filters.mining_admin.title": "Mining for admin",
  "filters.mining_admin.now": "Mining right now",
  "filters.miner_errors.title": "Miners with errors",
  "filters.miner_errors.value": "Show miner with errors",
  "filters.withoutflag.value": "Miners without flag",
  "filters.flag.title": "Miner flag",
  "filters.withoutplan.value": "Miners without plan",
  "filters.withoutcontract.value": "Miners without contract",
  "filters.mining_admin.setting": "The setting is enabled",
  "filters.pool": "Pool settings",
  "filters.customer": "Customer",
  "filters.mining_percent": "Percent of admin mining",
  "filters.speed_less": "Speed LESS than",
  "filters.default_speed.more": "Default speed MORE",
  "filters.default_speed.less": "Default speed LESS",
  "filters.instalation_date_less": "Installation date from",
  "filters.instalation_date_more": "Installation date to",
  "filters.speed_more": "Speed MORE than",
  "filters.speed_drop": "Speed drop percentage",
  "filters.type": "Miner type",
  "filters.contract": "Contract",
  "filters.plans": "Plan",
  "filters.plan": "Mininig plan",
  "filters.state": "State",
  "filters.algo": "Mining Algo",
  "filters.location": "Location",
  "filters.tags.title": "Client's tags:",
  "filters.buildings.title": "Location's buildings:",
  "filters.date_range.error": "Incorrect date range",

  //miners table
  "machines.table.user_ports_list": "Ports list",
  "machines.table.all": "All",
  "machines.table.id": "ID",
  "machines.table.type": "Type",
  "machines.table.algo": "Mining Algo",
  "machines.table.speed_default": "Speed (default)",
  "machines.table.speed_current": "Speed (current)",
  "machines.table.pool_settings": "Pool settings",
  "machines.table.state": "State",
  "machines.table.locations": "Locations",
  "machines.table.locations.empty": "No location",
  "machines.table.customer": "Client",
  "machines.table.empty": "Miner list is empty",

  "machines.table.unknown.created": "Created at",
  "machines.table.unknown.login": "Login",
  "machines.table.unknown.agent": "Software Agent",
  "machines.table.unknown.ip": "IP address",
  "machines.table.unknown.mac": "MAC address",
  "machines.table.warning":
    "When miner is transferred to this tab its ID changes. This change will be detected by the system when the miner is rebooted.",

  "machines.table.tabs.delete": "Delete",
  "machines.table.tabs.rename": "Rename",
  "machines.table.tabs.select_action": "Select action",
  "machines.table.tabs.move": "Move",
  "machines.table.tabs.copy": "Copy",

  "machines.table.tabGroups.inactive": "Inactive",
  "machines.table.tabGroups.inactive.title": "Inactive miners",
  "machines.table.tabs.all_tab": "All",
  "machines.table.tabs.all_tab.title": "All miners",
  "machines.table.tabs.racks_tab": "On shelves",
  "machines.table.tabs.racks_tab.title": "Miners installed on rack shelves",
  "machines.table.tabs.active_tab": "Active",
  "machines.table.tabs.active_tab.title": "Active miners",
  "machines.table.tabs.problem_tab": "Problem",
  "machines.table.tabs.problem_tab.title": "Problematic miners",
  "machines.table.tabs.offline_tab": "Disabled",
  "machines.table.tabs.offline_tab.title": "Disabled miners",
  "machines.table.tabs.incorrectid_tab": "Incorrect ID",
  "machines.table.tabs.incorrectid_tab.title": "Miners with the wrong ID",
  "machines.table.tabs.service_tab": "Service",
  "machines.table.tabs.service_tab.title": "Broken miners",
  "machines.table.tabs.store_tab": "Warehouse",
  "machines.table.tabs.store_tab.title": "Miners that are in the warehouse",
  "machines.table.tabs.retired_tab": "Retired",
  "machines.table.tabs.retired_tab.title": "Retired miners",
  "machines.table.tabs.unknown_tab": "Unknown",
  "machines.table.tabs.unknown_tab.title": "Unknown miners",

  "machines.table.tabs.hide_other_miners": "Hide other tabs' equipment",

  "machines.table.tabs.select.title": "Select section",
  "machines.table.tabs.select.addStatus": "Add section",

  //connect/delete miner hints
  "machines.hint.connect": "Proxy settings",
  "machines.hint.delete": "Delete miner",
  "machines.hint.configure": "Configure miner",
  "machines.hint.deselect_all": "Deselect all miners to apply new options",
  "machines.hint.miner_qr": "Miner QR code",
  "machines.hint.minerId": "Miner ID",

  "machines.actions": "Actions",
  "machines.actions.configure": "Configure selected",
  "machines.actions.delete": "Delete selected",
  "machines.actions.move": "Move selected",
  "machines.actions.print": "Print QR codes",
  "machines.actions.configure.hint": "Configure selected miners",
  "machines.actions.delete.hint": "Delete selected miners",
  "machines.actions.move.hint": "Move selected miners",
  "machines.actions.print.hint": "Print QR codes for selected miners",
  "machines.actions.delete.confirm.1":
    "Are you sure you want to delete # miners?",
  "machines.actions.delete.confirm.2":
    "Are you sure you want to delete # miners?",
  "machines.actions.delete.confirm.3":
    "Are you sure you want to delete # miner?",
  "machines.actions.delete.error": "Error!",
  "machines.actions.delete.error.hint":
    "The following errors occurred when deleting miners:",

  //miner ID field
  "machines.miner_row.miner_id.hint": `Use dashes "-" for autoplacement. \n Ex: 001-C001-001A11`,
  "machines.miner_row.miner_id.confirm_change": `Do you want to save a new ID "{newId}" ?`,
  "machines.miner_row.miner_id.eqaul_id": `This miner id already exists`,
  "machines.miner_row.miner_id.restore": `Return the miner to the shelf`,
  "machines.miner_row.error_hint": "The miner is malfunctioning",
  "machines.miner_row.unknown_id": "Panel ID doesn't match miner ID",

  //more
  //plan
  "plan.title": "Plan:",
  "plan.paused": "Paused",
  "plan.from": "From:",
  "plan.until": "Until:",
  "machines.more.clone_settings": "Clone",
  "machines.more.individualChart": "Individual chart",
  "machines.more.settings": "Settings",
  "machines.more.control": "Control",
  "machines.more.clone_settings_title": "Cloned settings",
  "machines.more.hashrate.title": "Hashrate",
  "machines.more.settings.messages.title": "Your messages",
  "machines.more.settings.messages.title_admin": "Messages",
  "machines.more.settings.messages.title_user": "Messages",
  "machines.more.settings.messages.placeholder": "Enter the message",
  "machines.more.settings.messages.empty": "No messages",
  "machines.more.settings.messages.moscow_time": "Moscow Time",
  "machines.more.settings.messages.field": "Message",
  "machines.more.settings.messages.btn": "Send",
  "machines.more.settings.personal.title": "Admin notes",
  "machines.more.settings.personal.title_user": "User notes",
  "machines.more.settings.personal.title_sync": "Sync notes",
  "machines.more.settings.personal.field": "Make a note",
  "machines.more.settings.personal.unsaved": "Unsaved",
  "machines.more.settings.personal.btn": "Save",
  "machines.more.settings.miner_errors.title": "Technical errors",
  "machines.more.settings.miner_errors.subtitle": "Errors history",
  "machines.more.settings.miner_errors.col-1": "Code",
  "machines.more.settings.miner_errors.col-2": "Type",
  "machines.more.settings.miner_errors.col-3": "Suggestion",
  "machines.more.settings.miner_errors.col-4": "Date",
  "machines.more.settings.minerData.requestSave.title":
    "Save changes to miner data?",
  "machines.more.settings.minerData.requestSave.fields": "Changed fields:",
  "machines.more.admin_table.title": "Miner will change pool to",
  "machines.more.serial.title": "Serial number",
  "machines.more.model.title": "Model of miner",
  "machines.more.instalation_date.title": "Instalation Date",
  "machines.more.photos.title": "Miner photos",
  "machines.more.serial.bage": "s/n",
  "machines.more.model.bage": "m/d",
  "machines.more.photos.empty": "Upload photos (no more than 5)",
  "machines.more.settings.personal_note": "Personal note",
  "machines.more.settings.ip": "IP",
  "machines.more.settings.mac": "MAC",
  "machines.more.settings.port": "Port",
  "machines.more.settings.password": "Password",
  "machines.more.settings.data_fields.edit": "Edit",
  "machines.more.settings.data_fields.save": "Save",
  "machines.more.settings.data_fields.reset": "Reset",
  "machines.more.settings.data_fields.ucp_no_contract_error": "The contract was not assigned to the miner",
  "machines.more.settings.data_fields.append_to_comment": "Append to comment",
  "machines.more.settings.ip.validation": "Ex: 10.1.12.88",
  "machines.more.settings.mac.validation": "Ex: CA:05:17:00:09:F9",
  "machines.more.settings.port.validation": "Ex: [001-21]",
  "machines.more.settings.password_switch": "Use contract password",
  "machines.more.settings.select_contract.label": "Contract",
  "machines.more.settings.select_plan.label": "Plan",
  "machines.more.settings.select_plan.disabled_hint": "Select the contract",
  "machines.more.setinngs.confirm.remove_plan.title":
    "The plan will be removed from the miner",
  "machines.more.setinngs.confirm.remove_plan.subtitle":
    "After this, the miner needs to be turned on manually. Continue?",

  //CLIENTS PAGE
  "clients.title": "Clients",
  "clients.technicals.title": "Technicals",
  "clients.add_new": "+ Add New",
  "clients.create_tech_user": "Add technician",
  "clients.table.id": "ID",
  "clients.table.email": "Email",
  "clients.table.role": "Role",
  "clients.table.customer": "Customer name",
  "clients.table.comment": "Comment",
  "clients.table.code": "Code to receive the miner",
  "clients.table.link": "Login link",
  "clients.table.2fa": "2FA",
  "clients.table.online": "Online",
  "clients.table.low": "Low",
  "clients.table.offline": "Offline",
  "clients.table.summ": "Total",
  "clients.table.color": "Color",
  "clients.table.row.enter_as_user": "enter as a user",
  "clients.table.row.2fa_yes": "Yes",
  "clients.table.row.2fa_no": "No",
  "clients.table.row.more.btn.hash": "Recent Hashrate",
  "clients.table.row.more.btn.state": "State changes in time",
  "clients.table.row.more.chart.hash": "Hashrate chart",
  "clients.table.row.more.chart.state": "State changes",
  "clients.table.row.empty": "User list is empty",
  "clients.table.row.new_tags": "New tag",
  "clients.table.row.tags.delete": "Delete tag",
  "clients.table.row.contracts.title": "Contracts",
  "clients.table.row.contracts_has": "Available",
  "clients.table.row.contracts_signed": "Signed",
  "clients.table.row.more.download": "Generate",
  "clients.table.row.more.download.progress": "Report downloading...",
  "clients.table.row.more.download.info": "Your report is loading...",
  "clients.table.row.more.download.info2":
    "Please don't leave the page and selected user.",
  "clients.table.empty": "User list is empty",
  "clients.comments.error.incorrect": "Incorrect string",
  "clients.comments.error.incorrect_max": "Maximum string length is 100 characters",

  //SETTINGS PAGE
  "settings.title": "Settings",
  "settings.templates.title": "Pool templates",
  "settings.templates.title.create": "Create Template",
  "settings.option.1": "Option 1",
  "settings.option.2": "Option 2",
  "settings.option.3": "Option 3",
  "settings.option.address": "Address",
  "settings.option.login": "Login",
  "settings.option.password": "Password",
  "settings.option.divider": "Divider",
  "settings.btn.used": "Used by {count} miners",
  "settings.btn.used.empty": "Not used",
  "settings.btn.default.title": "Default",
  "settings.btn.default.hint": "Set default setting",
  "settings.add_new_pool": "Add Pool Settings",
  "settings.controls.edit": "Edit pool",
  "settings.controls.cancel": "Cancel edit pool",
  "settings.controls.delete": "Delete pool",
  "settings.select_pool": "Select a pool",

  //LOCATIONS PAGE
  "locations.title": "Locations",
  "locations.table.name": "Site name",
  "locations.table.id": "Site ID",
  "locations.table.address": "Site address",
  "locations.table.appKey": "AppKey",
  "locations.table.coords": "Coordinates",
  "locations.table.notes": "Notes",
  "locations.add_new": "+ Add new Location",
  "locations.empty": "Location list is empty",
  "locations.delete_confirm":
    "All buildings and racks will be removed, and the miners will be transferred to the unallocated list. Continue?",
  "locations.buildings.delete_confirm":
    "All racks will be removed, and the miners will be transferred to the unallocated list. Continue?",
  //location more
  "location.__delete": "Delete",
  "location.building": "Building ID:",
  "location.building.info.cancel": "Cancel",
  "location.building.add_new": "+Building",
  "location.building.address": "Address:",
  "location.building.graph": "Graph",
  "location.additional_title.available_racks": "Available Racks",
  "location.additional_title.available_equipment": "Available Equipment",
  "location.rackTable.rotate": "Rotate",
  "location.rackTable.align": "Align",
  "location.rackTable.rotate.title": "Show connected equipment of miners",
  "location.rackTable.align.title": "Left side alignment",
  "location.available_racks.empty": "No available racks",
  "location.available_racks.create": "Create a new rack",
  "location.rackTable.rack.edit": "Edit",
  "location.rackTable.rack.delete": "Delete",
  "location.rackTable.rack.sure_delete":
    "Do you really want to remove the rack?",
  "location.rackTable.rack_template.sure_delete":
    "Do you really want to remove the rack template?",
  "location.rackTable.rack.no_undo":
    "It will be impossible to undo the deletion",
  "location.clients.title": "Clients:",
  "location.unnalocated.title": "Pool of unallocated miners:",
  "location.unnalocated.empty": "No unnalocated miners",
  "location.equipment.network": "network hardware",
  "location.equipment.electrical": "electrical equipment",
  "location.available_equipment.connect_all": "Connect all miners",
  "location.available_equipment.title": "Equipments",
  "location.available_equipment.network": "Network",
  "location.available_equipment.electrical": "Electrical",
  "location.equipment.connection_info.placeholder": "{type} Connection info",
  "location.equipment.connection_info.apply": "Apply",
  "location.equipment.connection_info.cancel": "Cancel",
  "location.rack.rack_item.back.equipment.sure_change":
    "Are you sure want to change an equipment?",
  "location.rack.rack_item.back.equipment.sure_delete":
    "Are you sure you want to remove an equipment ?",
  "location.rack.rack_item.info": "Info",
  "location.rack.rack_item.delete": "Delete",
  // "location.rack.rack_item.delete_confirm": 'Remove miner "{name}" ?',
  "location.rack.rack_item.delete_confirm": "Remove miner from item ?",
  "location.rack.confirm_save_rackId":
    "You don't save a new Rack ID. Save now?",

  //ACCOUNT PAGE
  "account.title": "Account",
  "account.add": "Add new {type}",
  "account.userCode": "Your miner transfer ID",
  "account.controllerId": "Admin code for controller",

  //RESTORE PAGE
  "restore.btn": "Restore",

  //CONTRACTS PAGE
  "contracts.title": "Management",
  "contracts.btn.name_contracts": "Contracts",
  "contracts.btn.name_plans": "Plans",
  "contracts.btn.name_profiles": "Miner profiles",
  "contracts.btn.name_parts": "Parts",
  "contracts.btn.name_tags": "RFID",
  "contracts.selector.lable": "Contract selector",
  "contracts.selector.edit": "Edit",
  "contracts.selector.edit__cancel": "Cancel",
  "contracts.selector.delete": "Delete",
  "contracts.selector.delete_contract": "Delete contract",
  "contracts.selector.clearing_option": "No contract",
  "contracts.selector.cannot_save_plan": "Save the contract firstly",
  "contracts.create_new": "Create new contract",
  "contracts.plan.create_new": "Create new plan",
  "contracts.plan.delete_plan": "Delete plan",
  "contracts.info.name": "Name",
  "contracts.info.client": "Client",
  "contracts.info.password": "Password",
  "contracts.info.electro_cost": "Electricity cost, kWh",
  "contracts.info.electro_cost__bage": "RUB",
  "contracts.plan_info.title": "Plan Details:",
  "contracts.plan_info.plans_selector.placeholder": "Select plans",
  "contracts.plan_info.used_in_contracts": "Used in contracts:",
  "contracts.plan_info.applied": "Applied for: ",
  "contracts.plan_info.applied.time.week": "Week",
  "contracts.plan_info.applied.time.month": "Calendar",
  "contracts.plan_info.periods.title": "Time periods",
  "contracts.plan_info.mining_descr":
    "Days that are not cheked will have mining always On",
  "manage.plan_info.periods.title__1": "On",
  "manage.plan_info.periods.title__2": "Add interval",
  "manage.plan_info.template.title": "Template",
  "manage.plan_info.template.confirm": "Are you sure want to resave template?",
  "manage.plan_info.template.delete_confirm":
    "Are you sure want to delete template?",
  "manage.plan_info.delete_plan": "Are you sure you want to delete the plan?",
  "manage.plan_info.skip": "Skip",
  "manage.plan_info.now": "Now",
  "manage.plan_info.used_plan": "Used plan:",
  "manage.plan_info.unused_plan": "Unused plan:",
  "manage.plan_info.interval": "Interval:",
  "manage.plan_info.attention": "Attention!",
  "manage.plan_info.skip_interval_deletion": "The interval(s) after and/or before the skip will be deleted. Continue?",
  "manage.plan_info.error_time_after_time": "End time must be after start time",
  "contracts.conditions.title": "Conditions of a contract:",
  "contracts.plan.select_plan": "Select plan",
  "contracts.btn.save": "Save",
  "contracts.btn.cancel": "Cancel",
  "contracts.files.too_large": "File is too large",
  "manage.create.profile": "Create profile",
  "manage.selector.profile": "Select a profile",
  "manage.profile.width": "Width",
  "manage.profile.height": "Height",
  "manage.profile.depth": "Depth",
  "manage.profile.params.unit": "{value} {unit}",
  "manage.profile.volume": "Volume",
  "manage.profile.delete.title": "You want to delete profile?",
  "manage.profile.delete.error": "The profile used in miners: ",
  "manage.parts.title": "Parts",
  "manage.parts.in_stock": "In stock",
  "manage.parts.in_use": "In use",
  "manage.parts.discarded": "Discarded",
  "manage.parts.create": "Create one",
  "manage.parts.table.head.photo": "Photo",
  "manage.parts.table.head.part_name": "Part name",
  "manage.parts.table.head.id": "ID",
  "manage.parts.table.head.owner": "Owner",
  "manage.parts.table.head.location": "Location",
  "manage.parts.table.head.SAP_ID": "SAP ID",
  "manage.parts.table.head.created": "Created",
  "manage.parts.table.head.comments": "Comments",
  "manage.tags.title": "Templates",
  "manage.tags.managment.add_tag": "Add template",
  "manage.tags.managment.delete_template": "Delete template",
  "manage.tags.managment.template_name": "Name",
  "manage.tags.managment.templateDetails":
    "This template has the following tags attached: ",
  "manage.tags.reports.title": "Tag Reports",
  "manage.tags.reports.reportDate": "Report date",
  "manage.tags.managment.templates.title": "Tag templates",
  "manage.tags.managment.selectTag": "Select template",
  "manage.tags.managment.measurement_add": "Add parameter",
  "manage.tags.managment.measurement.title": "Param #{num}",
  "manage.tags.managment.template_radiolabels.title":
    "Last scan of template tags",
  "manage.tags.managment.template_radiolabels.item.name": "Name",
  "manage.tags.managment.template_radiolabels.item.location": "Location",
  "manage.tags.managment.template_radiolabels.item.serial": "Serial",
  "manage.tags.managment.template_radiolabels.item.params": "Params",
  "manage.tags.managment.template_radiolabels.item.delete": "Delete",
  "manage.tags.managment.template_radiolabels.item.edit": "Edit",
  "manage.tags.managment.reports.filter.rfid": "RFID tag",
  "manage.tags.tooltip.id": "ID",
  "manage.tags.tooltip.location": "Location",
  "manage.tags.tooltip.when": "Date",
  "manage.tags.tooltip.template": "Template",
  "manage.tags.tooltip.serial": "S/N",
  "manage.tags.all_radiolabels": "All RFID tags",
  "manage.tags.managment.error.tag_name_too_short":
    "Template name must be at least 5 characters long",
  "manage.tags.managment.error.tag_name_too_long":
    "Template name must be no more than 100 characters",
  "manage.tags.managment.error.measurement_empty": "Parameter cannot be empty",
  "manage.tags.managment.error.measurement_duplicate":
    "Parameters must be unique",

  "manage.planslist.active_plan": "Active plan:",
  "manage.planslist.contracts": "Сontracts:",
  "manage.planslist.intervals": "Intervals:",

  "manage.planslist.week_excluded": "Unused",
  "manage.planslist.week_unused": "Overridden",

  "manage.planinfo.ranges_off": "Inactive",

  "manage.planslist.warning.intervals_disabled_all": "Будет отключено у всех",
  "manage.planslist.warning.intervals_enabled_all": "Будет включено у всех",

  "manage.planinfo.editor": "Editor",
  "manage.planinfo.plans_list": "Plans list",


  //MESSENDGER PAGE
  "messenger.tabs.admin": "Chat with Admin",
  "messenger.tabs.support": "Chat with Support",
  "messenger.tabs.users": "Chat with Users",
  "messenger.tabs.admins": "Chat with Admins",
  "messenger.input.placeholder": "Type your message here…",
  "messenger.message.you": "You",

  //NOTIFICATIONS PAGE
  "notifications.channels.general": "General notice",
  "notifications.channels.title": "Notification Channels",
  "notifications.channels.tg.notConnected": "Telegram bot not connected",
  "notifications.channels.tg.connect": "Connect Bot",
  "notifications.channels.email.notVerified": "Email not verified",
  "notifications.channels.email.verify": "Verify Email",
  "notifications.channels.apple.push": "Push",
  "notifications.channels.apple.ios": "iOS only",
  "notifications.channels.connected": "Connected",
  "notifications.channels.condition.hashrateBelow": "Hashrate below",
  "notifications.channels.condition.rejects": "More rejects",
  "notifications.channels.condition.andOr": "and/or",
  "notifications.channels.condition.fromDefault": "From nominal",
  "notifications.channels.message.title": "Message",
  "notifications.groups.title": "Notification Groups",
  "notifications.groups.createGroup": "Create a new group",
  "notifications.groups.table.head.name": "Name",
  "notifications.groups.table.head.status": "Status",
  "notifications.groups.table.head.numberOfMiners": "Number of Miners",
  "notifications.groups.table.head.hashrateBelow": "Hashrate below",
  "notifications.groups.table.head.rejects": "Rejects",
  "notifications.groups.table.head.channels": "Channels",
  "notifications.groups.table.head.reportTime": "Report time (UTC)",
  "notifications.groups.table.data.status.active": "Active",
  "notifications.groups.table.data.status.inactive": "Inactive",
  "notifications.groups.table.data.hashrateBelow.fromDefault": "From nominal",
  "notifications.groups.group.head.minerId": "Miner ID",
  "notifications.groups.group.head.type": "Type",
  "notifications.groups.group.head.state": "State",
  "notifications.groups.group.head.currentHashrate": "Current hashrate",
  "notifications.groups.group.head.defaultHashrate": "Default hashrate",
  "notifications.groups.group.head.hashrateBelow": "Notify when hashrate below (TH/s)",
  "notifications.groups.group.head.settings": "Individual settings",
  "notifications.history.title": "Notification History",
  "notifications.history.tools.selectDate": "Select date",
  "notifications.history.tools.selectGroup": "Select group",
  "notifications.history.table.head.date": "Date",
  "notifications.history.table.head.groupName": "Group name",
  "notifications.history.table.head.channels": "Channels",
  "notifications.history.table.head.status": "Status",
  "notifications.channelName.email": "Email",
  "notifications.channelName.push": "Push",
  "notifications.channelName.tg": "Telegram group",

  //Transliting component
  "transliting_tooltip.text":
    "The letters Ru have been replaced by the letters Eng",

  //NOTIFICATIONS
  //success
  "notifications.success": "Success",
  "notifications.check_email": "Check your email for confirmation link",
  "notifications.user_created": "User was created",
  "notifications.email.verified": "Email was verified",
  "notifications.password.restored": "Password was restored",
  "notifications.copied": "Copied",
  "notifications.saved": "Saved",
  "notifications.cleared": "Cleared",
  "notifications.loading": "Loading...",

  //errors
  "notifications.error.fill": "Please, fill in all fields",
  "notifications.error.match": "Passwords must match",
  "notifications.error.length":
    "The password length cannot be less than 6 characters",
  "notifications.error.name": "Field is required",
  "notifications.error.password": "Enter your own password",
  "notifications.error.symbols": "Special characters are not allowed",
  "notifications.error.duplicate_params": "Parameter names must be unique",
  "notifications.error.miner_settings.fill": "Fill the setting first",
  "notifications.error.miner_settings.miners": "Please, select miners",
  "notifications.error.search.length": "Should not be less than 3 letters",
  "notifications.error.add_pool_setting.protocol":
    "Please, check the address. Ex: - stratum+tcp://stratum.test.com:3333",
  "notifications.error.add_pool_setting.check":
    "Please check that all fields are filled correctly. Otherwise, your mining operations may experience interruptions.",
  "notifications.error.add_pool_setting.some_errors": "Some fields are empty or invalid",
  "notifications.error.miner_plan.name": "Please, fill name of the plan",
  "notifications.error.miner_plan.length":
    "Plan name should be more than 3 letters",
  "notifications.error.miner_plan.days": "Please, select at least 1 day",
  "notifications.error.miner_plan.period_default":
    "You already have a period [00:00 - 23:59]",
  "notifications.error.miner_plan.periods": "One or more periods intersect",
  "notifications.error.locations.sameId":
    "You can't create locations with the same ID",
  "notifications.error.locations.fill_fields":
    "Please fill in the marked fields.",
  "notifications.error.locations.more.delete_rack":
    "You can't delete the rack with active miners",
  "notifications.error.locations.more.edit_rack":
    "You can't delete miner from section.",
  "notifications.error.locations.more.rack_section":
    "You should select more than 1 section",
  "notifications.error.locations.more.merge":
    "You cannot merge miner, because the size of the miner exceeds the empty sections.",
  "notifications.error.locations.more.merge_lower_zero":
    "You cannot merge the miner because the merge section must be below or after the miner",
  "notifications.error.location.rackItem.move": "You cannot placed miner here",
  "notifications.error.unnalocated.unmerge": "You should unmerge item first",
  "notifications.error.locations.rack.name_already_in_use": "Name is already in use",
  "notifications.error.locations.rack.wrong_name_format": "Wrong name format",

  //info
  "notifications.info.delete": "Delete",
  "notifications.info.registration": "Registration confirmed",
  "notifications.info.timer.title": "Please wait until the timer ends",
  "notifications.info.timer.hasTimers":
    "Please wait until the timer in the miners ends:",
  //COMPONENTS

  //selectors
  "selector.all": "All",
  //more/less
  "more.closed": "More",
  "more.opened": "Less",
  //inputSelector , pool and fields (prev\current)
  "change_setting.current": "Current:",
  "change_setting.prev": "Previous:",
  "change_setting.admin_setting": "Admin's setting",
  "change_setting.user_pools": "User pools:",
  "change_setting.admin_mining_is_on": "Blocked while admin mining",
  //adminSettings
  "admin_settings.custom": "Custom",
  //table sorting (saved\cleared)
  "table_sorting.title.saved": "Save table filters",
  "table_sorting.title.cleared": "Delete table filters",

  //algorithm
  "algo.label": "Algorithm",
  "algo.all": "All",
  "algo.error": "No pool setting",
  //plan time
  "plan_time.from": "From:",
  "plan_time.until": "Until:",
  //selector (miner plan)
  "selector.miner_plan.create": "Create",
  "selector.miner_plan.view": "View",
  "selector.miner_plan.clear": "Clear",
  "selector.plan.default": "No plan",
  //chart hashrate
  "chart_hash.period": "Time period",
  "chart_hash.time_zone": "Time zone: Moscow",
  "chart_hash.empty_data": "Chart data is empty",
  "chart_hash.last_info.speed_now": "Speed now:",
  "chart_hash.last_info.speed": "Speed: ",
  "chart_hash.last_info.time": "Time: ",
  "chart.hashrate": "Hasrate",
  "chart.reject_rate": "Reject Rate",
  "chart.scale": "Scale",
  //chart state
  "chart_state.total": "Total:",
  "chart_state.empty_filtered": "No filtered miners",
  "chart_state.last_change": "Last change:",
  "chart_state.speed": "Speed: ",
  "chart_state.search.clear": "Clear",
  "chart_state.search.empty": "No miners with ID",
  "chart_state.search.placeholder": "Miner #",
  "chart_state.miner_id": "Miner #",
  "chart_state.time": "Time: ",
  "chart_state.empty_data": "Chart data is empty",
  // RateDropSelector
  "rate_drop.unset": "Unset",
  "rate_drop.speed_drop": "speed drop",
  "rate_drop.speed_drop_info":
    "select miners for which the hashrate has dropped by {percent}% or more.",
  "mining_percent.unset": "Unset",
  "mining_percent.less_than": "less than",

  // MODALS
  // modal order a call
  "modal.header.title": "Request",
  "modal.header.subtitle": "Fill contact details",
  "modal.name": "Name",
  "modal.email": "Email",
  "modal.phone": "Phone number",
  "modal.telegram": "Telegram username",
  "modal.textarea": "Additional Comments",
  "modal.textarea.placeholder":
    "You can write about type of your machines, models of your machines, how much of these machines and add any comment.",
  "modal.btn": "Send",
  "modal.btn.loading": "Sending...",
  "modal.choice.title": "Select one",

  // add pool modal
  "modal.pool.title": "Add Pool Settings",
  "modal.pool.title_edit": "Edit",
  "modal.pool.title_proxy": "Pools settings",
  "modal.pool.name": "Name",
  "modal.pool.confirm_text":
    "I confirm that everything is OK and I want to continue",
  "modal.pool.btn.cancel": "Cancel",
  "modal.pool.btn.save": "Save",
  "modal.pool.address_required": "Address is required",
  "modal.pool.address_incorrect": "Address is incorrect",
  "modal.pool.login_required": "Login is required",
  "modal.pool.password_required": "Password is required",
  //add new client modal
  "modal.new_client.title": "Add New Client",
  "modal.new_client.email": "Email",
  "modal.new_client.password": "Password",
  "modal.new_client.generate": "Generate random password",
  "modal.new_client.save": "Save",

  //add miners table tab modal
  "modal.new_miners_tab.title": "Add miners section",
  "modal.new_miners_tab.titleRename": "Rename miners section",
  "modal.new_miners_tab.input_name": "Input section name",
  "modal.new_miners_tab.add": "Add section",
  "modal.new_miners_tab.rename": "Rename section",

  // add new location modal
  "modal.location.title": "Add New Location",
  "modal.location.title_edit": "Edit Location",
  "modal.location.btn.cancel": "Cancel",
  "modal.location.btn.save": "Save",
  "modal.location.name": "Name",
  "modal.location.id": "ID",
  "modal.location.address": "Address",
  "modal.location.coords": "Coordinates on the map",
  "modal.location.notes": "Notes",
  "modal.location.help.1": "Put your mouse on the object",
  "modal.location.help.2": "Make a right click",
  "modal.location.help.3": "Select coordinates in the menu",
  "modal.location.help.4": "Paste coordinates here",

  // confirm modal
  "modal.confirm.title": "Are you sure?",
  "modal.confirm.btn.yes": "Yes",
  "modal.confirm.btn.no": "No",
  "modal.confirm.btn.cancel": "Cancel",
  "modal.confirm.delete": "Delete {name}?",

  // error modal
  "modal.error.title": "Error!",
  "modal.error.btn.ok": "OK",

  //delete miner modal
  "modal.delete_miner.title": "Delete miner {miner}",
  "modal.delete_miner.sure":
    "This will delete all saved data about this miner. Continue?",
  "modal.delete_miner.btn.cancel": "Cancel",
  "modal.delete_miner.btn.continue": "Continue",

  //start\stop mining
  "modal.start_miming.one": "Start miner {miner}?",
  "modal.stop_mining.one": "Stop miner {miner}?",
  "modal.booston_mining": "Boost miner {miner}?",
  "modal.boostoff_mining": "Boostoff miner {miner}?",
  "modal.check_mining.one": "Check miner {miner}?",
  "modal.start_miming": "Start miners?",
  "modal.check_mining.all": "Check selected miners?",
  "modal.booston_mining.all": "Booston selected miners?",
  "modal.boostoff_mining.all": "Boostoff selected miners?",
  "modal.check_mining.all.all":
    "All miners will now be checked. If you want to check specific miners, please select them below",
  //forgot modal
  "modal.forgot.title": "Forgot your password?",
  "modal.forgot.email": "Email",
  "modal.forgot.send": "Send",

  //two fa modal
  "modal.2fa.title": "Google 2FA",
  "modal.2fa.title_reset": "Reset Google 2FA",
  "modal.2fa.reset_code": "Reset code",
  "modal.2fa.google_code": "Enter Google 2FA code",
  "modal.2fa.lost_code": "Lost your code?",
  "modal.2fa.return": "Return",
  "modal.2fa.confirm": "Confirm",

  //QR modal
  "modal.qr.title":
    "Scan this code with your phone to subscribe for the account notifications.",
  "modal.qr.bottom":
    "Alternatively, you may copy the code above and manually enter it here",

  // create 2FA modal
  "modal.create_2fa.title":
    "Please, save this code in save place. You will not be able to login if you lose it",
  "modal.create_2fa.restore": "This is your restore code:",
  "modal.create_2fa.loose": "Use it if you loose access to QR code.",
  //create plan modal
  "modal.create_plan.title": "Create Mining Plan",
  "modal.create_plan.delete": "Delete plan",
  "modal.create_plan.plan.name": "Name of the Plan",
  "modal.create_plan.plan.apply_title": "Apply for:",
  "modal.create_plan.plan.days_not_checked":
    "Days that are not checked will have mining always On.",
  "modal.create_plan.plan.except": "Mining is always ON, except:",
  "modal.create_plan.btn.apply": "Apply",
  "modal.create_plan.btn.create": "Create",
  //add email modal
  "modal.add_email.title": "Add new notification email",
  "modal.add_email.email": "Email",
  "modal.add_email.apply": "Apply",
  // edit account modal
  "modal.edit_account.title": "Account Settings",
  "modal.edit_account.app_photo": "Add photo",
  "modal.edit_account.name": "Name",
  "modal.edit_account.2fa_text": "Two-factor authentication",
  "modal.edit_account.email": "Account Email",
  "modal.edit_account.private": "private",
  "modal.edit_account.public": "public",
  "modal.edit_account.new_password": "New Password",
  "modal.edit_account.repeat_password": "Repeat New Password",
  "modal.edit_account.telegram": "Telegram username",
  "modal.edit_account.about": "About",
  "modal.edit_account.summary.title": "Send offline miner summary to:",
  "modal.edit_account.summary.email": "Email (all accounts)",
  "modal.edit_account.summary.telegrams": "Telegram (all accounts)",
  "modal.edit_account.password": "Input your Current password to save changes",
  "modal.edit_account.save": "Save",

  //create object modal
  "modal.create_object.title": "Adding new Building",
  "modal.create_object.building_id": "Building ID",
  "modal.create_object.btn": "Create",

  //equipment modal
  "modal.equipment.create": "Create Equipment",
  "modal.equipment.edit": "Edit Equipment",
  "modal.equipment.edit.name": "Edit name:",
  "modal.equipment.choose": "Choose an equipment type:",
  "modal.equipment.notes.placeholder": "Equipment notes",
  "modal.equipment.notes.color": "Color",
  "modal.equipment.btn_save": "Save",

  // rack modal
  "modal.rack.title.edit": "Edit rack",
  "modal.rack.title.edit_available": "Edit available rack",
  "modal.rack.title.create": "Create a new rack",
  "modal.rack.select.type": "Select type of rack",
  "modal.rack.select.own": "Create own rack type",
  "modal.rack.warning.remove_miners": "To edit rack ID remove all miners from the shelves",
  "modal.rack.label.enter_rack_id": "Enter rack ID",

  //change client password modal
  "modal.change_pass.title": "Change client's password",
  "modal.change_pass.placeholder": "Enter a new password",
  "modal.change_pass.save": "Save",
  "modal.change_pass.cancel": "Cancel",

  //create contract
  "modal.create_contract.title": "Create a new contract",

  //create miner profile
  "modal.create_profile.title": "Create a new miner profile",

  // edit template modal
  "modal.editTemplate.title.add": "Add tempate",
  "modal.editTemplate.title.edit": "Edit template",
  "modal.editTemplate.title.name": "Name",
  "modal.editTemplate.title.enterName": "Enter name",
  "modal.editTemplate.actions.deleteTemplate": "Delete template",
  "modal.editTemplate.actions.add": "Add",
  "modal.editTemplate.actions.save": "Save",
  "modal.editTemplate.actions.cancel": "Cancel",

  // edit general notifications
  "modal.editGeneralNotifications.title": "Edit General Notifications",
  "modal.editGeneralNotifications.title.email": "Email",
  "modal.editGeneralNotifications.title.tg": "Telegram bot",
  "modal.editGeneralNotifications.title.message": "Message",
  "modal.editGeneralNotifications.title.hashrateBelow": "Hashrate below",
  "modal.editGeneralNotifications.title.from": "From",
  "modal.editGeneralNotifications.title.rejects": "Rejects",
  "modal.editGeneralNotifications.buttons.save": "Save",
  "modal.editGeneralNotifications.buttons.cancel": "Cancel",

  // edit notification group
  "modal.editNotificationGroup.title.create": "Create a new group",
  "modal.editNotificationGroup.title.edit": "Edit group",
  "modal.editNotificationGroup.title.name": "Name",
  "modal.editNotificationGroup.title.hashrateBelow": "Hashrate below",
  "modal.editNotificationGroup.title.from": "Of total hashrate",
  "modal.editNotificationGroup.title.rejects": "More rejects",
  "modal.editNotificationGroup.title.status": "Status",
  "modal.editNotificationGroup.title.status.active": "Active",
  "modal.editNotificationGroup.title.status.inactive": "Inactive",
  "modal.editNotificationGroup.title.sendingMode": "Select the Report Sending Mode",
  "modal.editNotificationGroup.title.timeSlots": "Select time slots (UTC):",
  "modal.editNotificationGroup.title.timeSlots.details": "Send reports at specific times (e.g., every day at 09:00 UTC).",
  "modal.editNotificationGroup.title.triggered": "Triggered (by threshold)",
  "modal.editNotificationGroup.title.triggered.details": "Send reports when performance crosses the set threshold.",
  "modal.editNotificationGroup.title.notificationChannels": "Notification channels",
  "modal.editNotificationGroup.title.email": "Email",
  "modal.editNotificationGroup.title.tg": "Telegram Group",
  "modal.editNotificationGroup.title.push": "Push (iOS only)",
  "modal.editNotificationGroup.buttons.deleteGroup": "Delete group",
  "modal.editNotificationGroup.buttons.create": "Create a group",
  "modal.editNotificationGroup.buttons.save": "Save",
  "modal.editNotificationGroup.buttons.cancel": "Cancel",

  // edit notification miner
  "modal.editNotificationMiner.title": "Miner",
  "modal.editNotificationMiner.title.selectGroup": "Select Group",
  "modal.editNotificationMiner.title.hashrateBelow": "Hashrate below",
  "modal.editNotificationMiner.title.from": "Of total hashrate",
  "modal.editNotificationMiner.title.rejects": "More rejects",
  "modal.editNotificationMiner.buttons.save": "Save",
  "modal.editNotificationMiner.buttons.cancel": "Cancel",

  // assign notification group
  "modal.assignNotificationGroup.title.assign": "Assign",
  "modal.assignNotificationGroup.title.to": "to",
  "modal.assignNotificationGroup.selectGroup": "Select group",
  "modal.assignNotificationGroup.buttons.assign": "Assign",
  "modal.assignNotificationGroup.buttons.cancel": "Cancel",

  // move miners modal
  "modal.moveMiners.title": "Move miners",
  "modal.moveMiners.actions.ok": "Ok",
  "modal.moveMiners.actions.cancel": "Cancel",

  //modal move
  "modal.move.title.in_use": "Move part in Use",
  "modal.move.title.stock": "Move part in Stock",
  "modal.move.title.discarded": "Move part in Discarded",
  "modal.move.btn": "Move",

  //spare parts modal
  "modal.spare_part.title": "Create Part",
  "modal.spare_part.save_template": "Save to templates",
  "modal.spare_part.name.title": "Name",
  "modal.spare_part.name.owner": "Owner",
  "modal.spare_part.name.quantity": "Quantity",
  "modal.spare_part.name.location": "Location",
  "modal.spare_part.name.comments": "Comments",
  "modal.spare_part.name.upload.template": "Upload template",
  "modal.spare_part.name.upload.template_desc": "Select form templates library",
  "modal.spare_part.name.upload.template.subtitle":
    "Select part profile picture",
  "modal.spare_part.btn.create": "Create",
  "modal.spare_part.btn.cancel": "Cancel",

  // upload miner photo
  "modal.upload_photo.title": "Upload miner photos",
  "modal.upload_photo.max_count": "You can upload no more than 5 files",
  "modal.upload_photo.drop_text": "Click or drag file to this area to upload",

  //MINER LOG
  "miner_log.title": "Miners change log",
  "miner_log.info": `The miners below have been moved!
   Do not forget to change in the firmware.`,
  "miner_log.label.prev": "Prev miner ID",
  "miner_log.label.new": "New miner ID",
  "miner_log.cancel": "Cancel",
  "miner_log.clear": "Clear",

  "search_form.search": "Search",
  "search_form.machines.help1":
    'Enter "parameter" to search for the exact parameter.',
  "search_form.machines.help2":
    "Enter parameter1, parameter2 using comma as a divider to search for multiple parameters at the same time.",
  "state_selector.label.state": "State",

  //SPAREPARTS
  "spareparts.title": "Spare Parts",
  "spareparts.miner_id": "Miner ID",
  "spareparts.type": "Spare Part",
  "spareparts.confirm.delete": "Delete spare part?",
  "spareparts_types.confirm.delete": "Delete spare part type?",
  "spareparts.tab.title": "Spare Parts",
  "spareparts_type.tab.title": "Spare Part Types",
  // spareparts modals
  "spareparts.modal.add_type.title": "Create spare part type",
  "spareparts.modal.add_type.name": "Name",
  "modal.add_spareparts.title": "Create spare part",

  // socket
  "socket.messages.exec_command_sent": 'The "{command}" command was sent.',
  "socket.messages.exec_command_success":
    'The "{command}" command was executed successfully.',
  "socket.messages.exec_command_fail":
    'An error occurred while executing the command "{command}".',

  "miners.ports.access_miner": "Access miner",
  "miners.ports.list.port": "Port",
  "miners.ports.list.description": "ID",
  "miners.ports.list.target": "Target IP",
  "miners.ports.list.last_active": "Last active",
  "miners.ports.delete_port": "Delete port",
  "miners.ports.system_online": "System online",
  "miners.ports.system_offline": "System offline",

  "contract_and_plan.no_contract": "- no contract -",
  "contract_and_plan.no_plan": "- no plan -",

  "socket.status.connected": "Connected",
  "socket.status.reconnecting": "Reconnecting...",
  "socket.status.disconnected": "Disconnected",

  "roles.title": "Role",
  "roles.a": "Administrator",
  "roles.m": "Moderator",
  "roles.u": "User",
  "roles.t": "Technician",
  "roles.g": "God",
  "roles.s": "Super Administrator",

  "roles.admin": "Hosting",
  "roles.client": "Client",
  "roles.tech": "Technician",

  "role_switcher.mode": "Mode:",
  "role_switcher.client": "Client",
  "role_switcher.hosting": "Hosting",

  //COMMON
  "common.add": "Add",
  "common.delete": "Delete",
  "common.save": "Save",
  "common.flag.green": "Green",
  "common.flag.yellow": "Yellow",
  "common.flag.red": "Red",
  "common.flag.violet": "Violet",
  "common.flag.black": "Black",
  "common.flag.orange": "Orange",
  "common.no_items": "No items",
  "common.sort": "Sort",
  "common.disabled": "Disabled",
  "chunk_error_boundary.title": "Loading a new version...",
  "chunk_error_boundary.text": "Please wait",

  "CustomerSelector.hasNotFoundedUser": "Current customer was not found in the list. Please contact the developer.",
  "CustomerSelector.back_to_owner": "To owner (take miner from client)",
  "CustomerSelector.miners_count": "miners",


};
